module.exports = __webpack_public_path__ + "img/ppt-default-wap.3213ddb6.jpg";